import { createAction, createSlice } from "@reduxjs/toolkit";

interface DocumentsState {
    loading: boolean;
    error: string | null;
    myAcknowledgeProjects: any;
    myAcknowledgeCount: number;
    otherAcknowledgeProjects: any;
    otherAcknowledgeCount: number;
    myArchivedProjects: any;
    myArchivedCount: number;
    otherArchivedProjects: any;
    otherArchivedCount: number;
};

export const initialState: DocumentsState = {
    loading: false,
    error: null,
    myAcknowledgeProjects: [],
    myAcknowledgeCount: 0,
    otherAcknowledgeProjects: [],
    otherAcknowledgeCount: 0,
    myArchivedProjects: [],
    myArchivedCount: 0,
    otherArchivedProjects: [],
    otherArchivedCount: 0,
};

export const getmyAcknowledgeProjects = createAction("documents/getmyAcknowledgeProjects");
export const getOtherAcknowledgeProjects = createAction("documents/getOtherAcknowledgeProjects");
export const getmyArchivedProjects = createAction("documents/getmyArchivedProjects");
export const getOtherArchivedProjects = createAction("documents/getOtherArchivedProjects");

const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setMyAcknowledgeProjects(state, action) {
            state.myAcknowledgeProjects = action?.payload?.projects;
            state.myAcknowledgeCount = action?.payload?.projectsCount || 0;
        },
        setOtherAcknowledgeProjects(state, action) {
            state.otherAcknowledgeProjects = action?.payload?.projects;
            state.otherAcknowledgeCount = action?.payload?.projectsCount || 0;
        },
        setMyArchivedProjects(state, action) {
            state.myArchivedProjects = action?.payload?.projects;
            state.myArchivedCount = action?.payload?.projectsCount || 0;
        },
        setOtherArchivedProjects(state, action) {
            state.otherArchivedProjects = action?.payload?.projects;
            state.otherArchivedCount = action?.payload?.projectsCount || 0;
        },
        setLoading(state, action) {
            state.loading = action?.payload;
        },
        setError(state, action) {
            state.error = action?.payload;
        },
    },
});

export const { setMyAcknowledgeProjects, setOtherAcknowledgeProjects, setMyArchivedProjects, setOtherArchivedProjects, setLoading, setError } = documentsSlice.actions;
export default documentsSlice.reducer;
